/**
 * @deprecated import colors from @addi/foundation/dist/web/colors instead
 */
const Blue = {
    1: '#3154c5',
    2: '#3c65ec',
    3: '#6384eb',
    4: '#b1c1f5',
    5: '#f5f9fc',
    dark: '#202844',
    navy: '#f8fafb',
    light: '#3154c5',
    normal: '#334375',
    sixTerms: '#5886FF',
    threeTerms: '#4069DB',
    greaterTerms: '#2D52B4',
    stepperLightBlue: '#ecf0fc'
};
export default Blue;
//# sourceMappingURL=blue.js.map